import {addAlert} from '_app/shared/features/TransientNotifications/TransientNotificationsActions';
import {actionCreatorMake} from '_app/utils';
import {mediaVersionService, mediaService, mediaContentLibraryService} from '_app/services';

export default (function () {
	function shouldFetch() {
		return true; // TODO
	}

	function mediaItemFetch(id) {
		const itemRequest = actionCreatorMake('MEDIA_ITEM_REQUEST', 'id');
		const itemSuccess = actionCreatorMake('MEDIA_ITEM_SUCCESS', 'id', 'data', 'receivedAt');
		const itemFailure = actionCreatorMake('MEDIA_ITEM_FAILURE', 'id');

		return function(dispatch) {
			dispatch(itemRequest(id));

			return mediaService.get(id)
				.done(media => dispatch(itemSuccess(id, media, Date.now())))
				.fail((xhr, message) => {
					dispatch(addAlert('Error retrieving media: ' + message));
					dispatch(itemFailure(id));
				});
		};
	}

	function versionFetch(mediaId, versionId) {
		var versionsRequest = actionCreatorMake('MEDIA_VERSION_REQUEST', 'id');
		var versionsSuccess = actionCreatorMake('MEDIA_VERSION_SUCCESS', 'id', 'data');
		var versionsFailure = actionCreatorMake('MEDIA_VERSION_FAILURE', 'id');

		return function(dispatch) {
			const promise = versionId ?
				mediaVersionService.get(mediaId, versionId) :
				mediaVersionService.latest(mediaId);

			dispatch(versionsRequest(mediaId));

			return promise
				.done(data => dispatch(versionsSuccess(mediaId, data)))
				.fail((xhr, message) => {
					dispatch(addAlert(message));
					dispatch(versionsFailure(mediaId));
				});
		};
	}

	function itemsFetch(types, section, category, params, proxiedAsUserId) {
		return function (dispatch) {
			var query = itemsParseParams(params);
			var request = actionCreatorMake(types.request, 'section', 'category', 'params');
			var success = actionCreatorMake(types.success, 'section', 'category', 'params', 'data', 'receivedAt');
			var failure = actionCreatorMake(types.failure, 'section', 'category', 'params');
			var results = {};

			dispatch(request(section, category, params));

			return mediaContentLibraryService
				.Search(section, query, proxiedAsUserId)
				.then(function (result) {
					results.items = result.data.result;
					results.count = result.data.count;
					results.hasMore = result.data.hasMore;

					dispatch(success(section, category, query, results, Date.now()));
				})
				.catch(function (xhr, message) {
					dispatch(addAlert('Error retrieving media: ' + message));
					dispatch(failure(section, category, query));
				});
		};
	}

	function itemsParseParams(params) {
		var query = {};

		if (params.tag_ids) {
			for (let i = 0; i < params.tag_ids.length; i++) {
				query['tag_ids[' + i + ']'] = params.tag_ids[i];
			}
			delete params.tag_ids;
		}
		// eslint-disable-next-line no-unused-vars
		for (const key in params) {
			query[key] = params[key];
		}
		return query;
	}

	// Function that returns an action creator
	// Media items may be associated with multiples and should therefore be
	// stored the same way regardless of the state key.
	function itemsLoadFor(stateKey, types) {
		var stateLevels = stateKey.split('.');

		return function () {
			var args = Array.prototype.slice.call(arguments);

			return function (dispatch, getState) {
				var state = getState();

				stateLevels.forEach(function (key) {
					state = state[key]; // TODO: might need some error checking
				});
				const withState = args.slice();

				withState.unshift(state);
				if (shouldFetch.apply(this, withState)) {
					const withTypes = args.slice();

					withTypes.unshift(types);
					return dispatch(itemsFetch.apply(this, withTypes));
				}
			};
		};
	}

	return {
		mediaItemFetch,
		versionFetch,
		itemsLoadFor
	};
})();